export default __webpack_public_path__ + "static/media/CAPWEB-Contrataciones.df06fb58.pdf";